import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'reactstrap';
import PaymentSection from './components/PaymentSection';


const Payments = (props) => {
    //const selectedInvoiceFromProps = props.location.state.selectedInvoice !== null &&  props.location.state.selectedInvoice !== undefined ? props.location.state.selectedInvoice : null ;
    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 style={{ marginBottom: 15 }}>Pago de Facturas</h3>
                </Col>
            </Row>
            <Row>
                <PaymentSection selectedInvoiceFromProps={props.location.state} />
            </Row>
        </Container>
    )
}

export default Payments